export const freeSpaceAreaConstant = {
    GET_LAYER_STRUCTURES: 'GET_LAYER_STRUCTURES',
    SET_SELECTED_LAYER_TYPES: 'SET_SELECTED_LAYER_TYPES',
    SET_FREE_SPACE_SHOW_DIALOG: 'SET_FREE_SPACE_SHOW_DIALOG',

};

export default freeSpaceAreaConstant;